export const WIDTH = 24;
export const HEIGHT = 24;
export const BAR_WIDTH = 3;
export const BAR_HEIGHT = 6.5;
export const TOTAL_BARS = 8;
